'use client';

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { PropsWithChildren } from 'react';
import { useInView } from 'react-intersection-observer';
const RenderInView = t0 => {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      threshold: 0.5,
      triggerOnce: true
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    ref,
    inView
  } = useInView(t1);
  const t2 = inView && children;
  let t3;
  if ($[1] !== ref || $[2] !== t2) {
    t3 = <div ref={ref} data-sentry-component="RenderInView" data-sentry-source-file="index.tsx">{t2}</div>;
    $[1] = ref;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default RenderInView;